import React from 'react';
import { ReactComponent as Seat } from '@weezevent/throne/dist/images/seating/siege-available.svg';
import { Accordion, InputLabel, Input, DropdownLanguage, SelectLabel, Icon } from '@weezevent/nacre'; // eslint-disable-line
import ColorPicker from '../../../../components/color-picker';
import { useTranslation } from 'react-i18next';
import css from '../../chart-list.module.css';

function CategoryForm({ category, index, options, onDelete, form, setForm }) {
    const { t } = useTranslation();
    const [showPicker, setShowPicker] = React.useState(false);
    const [selected, setSelected] = React.useState(options[0]); // eslint-disable-line

    const { color, general_admission, translations, name } = category; // eslint-disable-line

    /* TODO 
        Commented items correspond to the category's name translations, which is actually not fully covered by Nacre's 
        DropdownLanguage component. Don't uncomment, don't delete.
    */

    const handleColor = React.useCallback(
        color => {
            let cat = form.categories;
            cat[index].color = color.hex;
            setForm('categories', cat);
        },
        [form.categories]
    );

    const handleType = React.useCallback(
        value => {
            let cat = form.categories;
            cat[index].general_admission = value;
            setForm('categories', cat);
        },
        [form.categories]
    );

    const handleName = React.useCallback(
        value => {
            let cat = form.categories;
            //if (selected === options[0]) {
            cat[index].name = value;
            //}
            //cat[index].translations['name'][selected] = value;
            setForm('categories', cat);
        },
        [form.categories]
    );

    return (
        <Accordion
            key={index}
            disableToggle
            openByDefault
            title={
                <div className={css['category-delete-btn']}>
                    <span className={css['category-index']}>
                        {t('ticket.chart.category')} {index + 1}
                    </span>
                    {onDelete && index > 0 && (
                        <span className={css['category-delete']} onClick={() => onDelete(index)}>
                            {t('ticket.common.action.delete')}
                        </span>
                    )}
                </div>
            }
        >
            <InputLabel
                label={
                    <div className={css['category-language-label']}>
                        {t('ticket.charts.newCategory.categoryName')}
                        {/* <DropdownLanguage items={options} onChange={setSelected} size="mini" value={selected} /> */}
                    </div>
                }
            />
            <Input
                onChange={(e, { value }) => handleName(value)}
                value={name}
                //value={Object.values(translations).length && translations['name'][selected]}
                placeholder={t('ticket.charts.newCategory.placeholder')}
            />
            <div className={css['category-color-container']}>
                <div
                    className={css['category-color-picker']}
                    onClick={() => setShowPicker(!showPicker)}
                    style={{
                        backgroundColor: color || '#FFF'
                    }}
                ></div>
                <span>{t('ticket.charts.newCategory.color')}</span>
            </div>
            <ColorPicker show={showPicker} disableAlpha onChange={handleColor} onClickAway={() => setShowPicker(false)} color={color || '#FFF'} />
            <SelectLabel
                disabled={category.uuid}
                onChange={handleType}
                label={t('ticket.charts.newCategory.category_type')}
                options={[
                    {
                        text: (
                            <div className={css['seated-zone-select']}>
                                <Seat className={css['seated-zone-icon']} /> {t('ticket.charts.newCategory.seated_zone')}
                            </div>
                        ),
                        value: false
                    },
                    {
                        text: (
                            <div className={css['seated-zone-select']}>
                                <Icon className={css['seated-zone-icon']} name="male" size="regular" /> {t('ticket.charts.newCategory.general_admission_zone')}
                            </div>
                        ),
                        value: true
                    }
                ]}
                value={general_admission}
            />
        </Accordion>
    );
}

export default CategoryForm;
